import axios from "axios";
import {getstore} from "store/ssqstore";
import {ACTION_TYPES} from "store/ActionTypes";

const CDN_DOMAIN = "https://ssqfd-abhdhraad3gkgbcg.a03.azurefd.net";

let _cdnBaseUrl = `${CDN_DOMAIN}/prod`;

export function getCdnBaseUrl() {
  return _cdnBaseUrl;
}

export async function initsvrconf(): Promise<void> {
  const store = getstore();
  if (!store) {
    console.error("store is not initialized");
    return;
  }
  try {
    const res = await axios.get("/api/config/get");
    store.dispatch({type: ACTION_TYPES.MAIN.SVR_CONF, payload: res.data});
    if (res.data?.containerName) {
      _cdnBaseUrl = `${CDN_DOMAIN}/${res.data.containerName}`;
    }
  } catch (e) {
    console.error("Failed to load server config", e);
  }
}
